import { useState, useEffect } from "react";
import projets from "../data/projets";
import ProjectCard from "./ProjectCard";

const Projets = () => {
  const [filter, setFilter] = useState("all");
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const categories = [
    { key: "all", label: "Tous les projets", icon: "🚀" },
    { key: "Web Application", label: "Applications Web", icon: "🌐" },
    { key: "Mobile App", label: "Apps Mobile", icon: "📱" },
    { key: "E-commerce", label: "E-commerce", icon: "🛒" },
    { key: "Portfolio", label: "Portfolio", icon: "💼" },
  ];

  const filteredProjects =
    filter === "all" ? projets : projets.filter((p) => p.category === filter);

  const highlightedProjects = projets.filter((p) => p.highlight);

  return (
    <div className="pt-24 lg:pt-32 relative overflow-hidden">
      {/* Arrière-plan animé avec bulles décoratives */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50"></div>
      <div className="absolute top-32 left-10 w-32 h-32 bg-primary/5 rounded-full animate-pulse"></div>
      <div
        className="absolute top-40 right-20 w-24 h-24 bg-blue-500/5 rounded-full animate-bounce"
        style={{ animationDelay: "1s" }}
      ></div>
      <div
        className="absolute bottom-40 left-20 w-40 h-40 bg-indigo-500/5 rounded-full animate-pulse"
        style={{ animationDelay: "2s" }}
      ></div>

      <div className="relative lg:mx-auto lg:max-w-7xl lg:w-full lg:pb-20">
        <div className="lg:px-8 px-4">
          {/* Header avec animation */}
          <div
            className={`text-center mb-16 transition-all duration-1000 ${
              isLoaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            <h1 className="lg:tracking-tight font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary via-blue-600 to-indigo-600 lg:text-6xl text-4xl mb-6">
              Mes Projets
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Une sélection de projets qui illustrent mes compétences et ma
              progression en développement web
            </p>
          </div>

          {/* Filtres avec design moderne */}
          <div
            className={`mb-12 transition-all duration-1000 delay-300 ${
              isLoaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((category) => (
                <button
                  key={category.key}
                  onClick={() => setFilter(category.key)}
                  className={`group relative px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 ui-btn ${
                    filter === category.key
                      ? "bg-gradient-to-r from-primary to-blue-600 text-white shadow-sm"
                      : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-200"
                  }`}
                >
                  <span className="relative z-10 flex items-center">
                    <span className="mr-2">{category.icon}</span>
                    {category.label}
                  </span>
                  {filter === category.key && (
                    <div className="absolute inset-0 rounded-lg bg-white/10 animate-pulse"></div>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Tous les projets */}
          <div
            className={`transition-all duration-1000 delay-400 ${
              isLoaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {filter === "all" ? "Tous mes projets" : `Projets ${filter}`}
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-primary to-blue-600 mx-auto rounded-full"></div>
            </div>

            <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8">
              {filteredProjects.map((projet, index) => (
                <ProjectCard key={projet.id} projet={projet} index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projets;
